import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import {
  RoutePath,
  sideBarNavigation,
  sideBarNavigationModerator,
} from "../../../utility/Constant";
import "./SideBar.css";
import { AiFillHome } from "react-icons/ai";
import { BsFillInfoCircleFill } from "react-icons/bs";
import {
  MdOutlineMiscellaneousServices,
  MdOutlineContentPaste,
  MdPersonSearch,
  MdContentPaste,
} from "react-icons/md";
import {
  FaProjectDiagram,
  FaBloggerB,
  FaBars,
  FaUserFriends,
  FaThList,
} from "react-icons/fa";
import { TiThListOutline } from "react-icons/ti";
import { SiMicrosoftteams, SiBloglovin } from "react-icons/si";
import { RiGalleryFill, RiListSettingsFill, RiTeamFill } from "react-icons/ri";
import { CgDockBottom } from "react-icons/cg";
import { GiThink } from "react-icons/gi";
import NestedSideButton from "./NestedSideButton";

const SideBar = ({ user }) => {
  const { role } = user;
  const {
    navBar,
    homeBanner,
    about,
    serviceContent,
    serviceList,
    projectContent,
    projectList,
    teamContent,
    teamList,
    expectation,
    clients,
    gallery,
    blogsContent,
    blogList,
    footer,
  } = RoutePath;

  const sidebarMenu =
    role === "admin" ? sideBarNavigation : sideBarNavigationModerator;

  return (
    <div className="fixed top-0 z-100 hidden lg:flex flex-col justify-between lg:px-6 xl:px-8 2xl:px-3 bg-[#2D3B42] h-[100vh]  lg:w-[290px] xl:w-[300px] 2xl:w-[300px] z-50">
      <div className="flex items-center justify-center pt-10 pb-3 ">
        <img
          src="https://i.ibb.co/N9NxLtB/innovia-text-only-white-small.png"
          alt=""
          className="w-[80%] pb-2"
        />
      </div>

      <div className="overflowScroll bg-[#415761] h-full flex flex-col  rounded-2xl px-2">
        {sidebarMenu.map((item, index) =>
          item[1] ? (
            <NestedSideButton key={index} index={index} items={item} />
          ) : (
            <NavLink
              className="md:px-2 px-2 navBtn text-left text-white font-semibold hover:bg-white hover:text-[#000000] py-1 my-2 transition  ease-in-out duration-300 text-lg md:text-md"
              to={item[0][1]}
              key={index}
            >
              <span className="text-2xl">{item[0][2]}</span>
              <span className="ml-5">{item[0][0]}</span>
            </NavLink>
          )
        )}
      </div>
      <div className="pb-10 pt-3">
        <p className="text-center text-white font-semibold">
          © Techno Haat Limited {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
};

export default SideBar;
